interface Location {
  country?: string;
  region?: string;
  city?: string;
}

export const getLocaleLocation = (
  data: RegionResponse,
  locale: string,
  location: Location,
): string[] => {
  const response: string[] = [];

  if (location.country) response.push(location.country);

  const regionData = data.find((item) => item.name["en"] === location.region);
  const regionName = regionData?.name[locale] || regionData?.name["en"];

  if (regionName) response.push(regionName);

  if (regionName) {
    const cityData = regionData.cities.find(
      (item) => item.name["en"] === location.city,
    );
    const cityName = cityData?.name[locale] || cityData?.name["en"];
    if (cityName) response.push(cityName);
  } else {
    for (const item of data) {
      const cityData = item.cities.find((c) => c.name["en"] === location.city);
      if (cityData) {
        const cityName = cityData?.name[locale] || cityData?.name["en"];
        if (cityName) response.push(cityName);
        break;
      }
    }
  }

  return response;
};
